import React from "react";
import Privacy from "./Privacy";
import PrivacyPt from "./PrivacyPt";

export default function PrivacyContent() {
  const language = localStorage.getItem("language");
  return language === "en" ? <Privacy /> : <PrivacyPt />;
}
